import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { motion } from "framer-motion";
import { formatINR } from "@/lib/api";
import QuantityStepper from "@/components/QuantityStepper";

const ProductCard = ({ product, index = 0 }) => {
    const [qty, setQty] = useState(1);
    if (!product) return null;
    const price = product.sizes?.[0]?.price_inr || product.base_price_inr;
    const href = `/product/${product.slug}${qty > 1 ? `?qty=${qty}` : ""}`;
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ delay: index * 0.05 }}
            className="tilt-card group relative rounded-3xl overflow-hidden glass"
            data-testid={`product-card-${product.slug}`}
        >
            <Link to={href} className="block">
                <div className="aspect-[4/5] relative overflow-hidden bg-gradient-to-br from-brand-cream to-brand-peach/50">
                    {product.images?.[0] && (
                        <img
                            src={product.images[0]}
                            alt={product.name}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                        />
                    )}
                    {product.is_featured && (
                        <span className="absolute top-3 left-3 bg-primary text-primary-foreground text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                            Bestseller
                        </span>
                    )}
                    <button
                        onClick={(e) => e.preventDefault()}
                        className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/80 backdrop-blur flex items-center justify-center hover:bg-white transition"
                        aria-label="Wishlist"
                    >
                        <Heart className="w-4 h-4" />
                    </button>
                </div>
                <div className="p-4 space-y-1.5">
                    <h3 className="font-display text-lg font-semibold group-hover:text-primary transition-colors">{product.name}</h3>
                    <p className="text-xs text-muted-foreground line-clamp-1">{product.tagline}</p>
                    <div className="flex items-end justify-between pt-1">
                        <div>
                            <div className="text-xs text-muted-foreground">{qty > 1 ? `${qty} × ${formatINR(price)}` : "Starting at"}</div>
                            <div className="font-display text-xl font-bold text-primary">{formatINR(price * qty)}</div>
                        </div>
                        <div className="flex flex-col items-end gap-1.5">
                            <QuantityStepper value={qty} onChange={setQty} testId={`product-qty-${product.slug}`} />
                            <span className="text-xs font-medium text-primary group-hover:translate-x-1 transition-transform">Customize →</span>
                        </div>
                    </div>
                </div>
            </Link>
        </motion.div>
    );
};

export default ProductCard;
